<template>
  <div>
    <h5 v-html="$t('filter.titles.' + key)" />
    <b-input-group>
      <b-input-group-text>
        <font-awesome-icon :icon="icon" />
      </b-input-group-text>

      <b-form-select
        v-model="selected"
        :options="years"
        @input="transmitNewValue()"
        :disabled="active"
      />
    </b-input-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    default: { type: Number, default: null },
    propKey: { type: String, default: null },
    active: { type: Boolean, default: false }
  },
  data() {
    return {
      selected: null,
      icon: "calendar-alt",
      key: "year",
    };
  },
  mounted() {
    this.getDefaultYear();
    this.key = this.propKey ? this.propKey : this.key;
    this.transmitNewValue();
  },
  computed: {
    ...mapGetters("dates", ["years"]),
  },
  methods: {
    getDefaultYear() {
      this.selected = this.default ? this.default : this.years[this.years.length-1];
    },
    transmitNewValue() {
      this.$emit("transmit", this.selected, this.key);
    },
  },
};
</script>
